// Binds links to the current page

otuApp.bindLinks = () => {
  console.log('binding links');

	$('.linkSignUp').one('click', function() {
    var url = new URL(document.location);
    var signup = new URL(__root_url__  + "signup");
    let params = url.searchParams;
    params.forEach((v,k)=>{
      signup.searchParams.append(k,v)
    })
    let name = params.get("name");
    window.open(signup.href,'_self');
  })


	$('.linkUpgrade').one('click', function() {
    window.open(__root_url__ + "upgrade",'_self');
  })

  $('[data-link]').one('click', function() {
    var link = $(this).attr('data-link');
    window.open(link,'_self');
  })



}